// 设备授权（RFC 8628）的网页一侧：AI 申请后，主人在 /device 页面核对并点同意或拒绝。
// 申请、轮询、发 Key 都在 studio；这里只读待批详情、提交决定（必须是本人登录的网页会话）。

import { request } from './client'
import type { OpenScope } from './hub/open'

const BASE = '/studio/api/open/device'

export interface DeviceRequest {
  userCode: string
  clientName: string
  /** 每个范围带一句人话，由 studio 给出（和给 AI 的说明书同一份）。 */
  scopes: { scope: OpenScope; text: string }[]
  requestedAt: string
  expiresAt: string
  secondsLeft: number
  keyName: string
  keyDays: number
}

const data = <T>(p: Promise<unknown>) => p.then((r) => (r as { data: T }).data)

export const getDeviceRequest = (code: string) => data<DeviceRequest>(request(`${BASE}/${encodeURIComponent(code)}`))
export const decideDevice = (code: string, approve: boolean) =>
  data<{ status: 'approved' | 'denied'; clientName: string }>(request(`${BASE}/${encodeURIComponent(code)}/${approve ? 'approve' : 'deny'}`, { method: 'POST', body: {} }))

/** 只认 8 位易读码（不含 0/O/1/I），写成 XXXX-XXXX。 */
export function normalizeUserCode(raw: string): string | null {
  const s = raw.toUpperCase().replace(/[^A-Z0-9]/g, '')
  return /^[A-HJ-NP-Z2-9]{8}$/.test(s) ? `${s.slice(0, 4)}-${s.slice(4)}` : null
}
